import { getPostJsonHeaders } from "@shared/axiosHelpers";
import { tryCatchHandlr } from "@shared/Utilities";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

import axios from "axios";

export const checkForRoutingNumber = async (agentId) => {
  try {
    await axios.get(`/users/${agentId}/check_for_routing_number`, getPostJsonHeaders());

    return {};
  } catch (e) {
    return createError(e);
  }
};

export const saveManagedNumber = async (agentId, number) => {
  try {
    await axios.post(`/users/${agentId}/save_managed_number`, { number }, getPostJsonHeaders());

    return {};
  } catch (e) {
    return createError(e);
  }
};

const createError = (e) => {
  const error = e.response ? e.response.data.error : "Something went wrong!";

  return { error };
};

export const createCnam = async ({ displayName, userId }) => {
  const [res, err] = await tryCatchHandlr(
    caseTransformingAxios.post(`/api/v4/cnam_registrations`, { displayName, userId }),
  );

  return { res, err };
};

export const updateCnam = async ({ displayName, id }) => {
  const [res, err] = await tryCatchHandlr(
    caseTransformingAxios.put(`/api/v4/cnam_registrations/${id}`, { displayName }),
  );

  return { res, err };
};

export const deleteCnam = async ({ id }) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.delete(`/api/v4/cnam_registrations/${id}`));

  return { res, err };
};
